import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  LABEL_FORM_FIELD_NAME_TITLE,
  LABEL_FORM_FIELD_TITLE_MAX_LENGTH,
} from '../../LabelForm.constants'

function TitleField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Label.TitleFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={LABEL_FORM_FIELD_TITLE_MAX_LENGTH}
      name={LABEL_FORM_FIELD_NAME_TITLE}
      placeholder={t('Label.TitleFieldPlaceholderKey')}
    />
  )
}

export default TitleField
